/**
 * Status labels shared by the request pages and the home dashboard, so a
 * request reads the same everywhere it appears.
 */

/** Tool access requests + tool proposals (4-stage lifecycle). */
export const REQUEST_STATUS_TONE = {
  // Access-request statuses (unchanged)
  pending:          { bg: '#FEF3C7', fg: '#92400E', label: 'Pending' },
  // Proposal statuses (4-stage lifecycle)
  pending_manager:  { bg: '#FEF3C7', fg: '#92400E', label: 'Awaiting manager' },
  pending_admin:    { bg: '#DBEAFE', fg: '#1E40AF', label: 'Awaiting admin' },
  approved:         { bg: '#DCFCE7', fg: '#166534', label: 'Added' },
  rejected:         { bg: '#FEE2E2', fg: '#991B1B', label: 'Rejected' },
};

/** Build-your-app requests. */
export const APP_STATUS_LABEL = {
  pending: 'Pending review',
  approved: 'Approved',
  provisioning: 'Provisioning',
  active: 'In progress',
  publish_requested: 'Publish requested',
  published: 'Published',
  rejected: 'Rejected',
};
